module.exports = __webpack_public_path__ + "static/media/mace-logo-charcoal.85feeb7e.svg";